import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { NotificationTheme } from '@fcom/ui-components';

@Component({
  selector: 'fin-flight-selection-warning',
  templateUrl: './flight-selection-warning.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlightSelectionWarningComponent {
  readonly NotificationTheme = NotificationTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  title = input<string>();
  warningNotificationMessage = input<string>();
  warningNotificationCtaText = input<string>();
  showWarningNotification = input(true);

  ctaClick = output<unknown>();
}
